/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Current_Password_RequiredInputs */

const en_common_current_password_required = /** @type {(inputs: Common_Current_Password_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Current password is required`)
};

const es_common_current_password_required = /** @type {(inputs: Common_Current_Password_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La contraseña actual es obligatoria`)
};

/**
* | output |
* | --- |
* | "Current password is required" |
*
* @param {Common_Current_Password_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_current_password_required = /** @type {((inputs?: Common_Current_Password_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Current_Password_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_current_password_required(inputs)
	return en_common_current_password_required(inputs)
});